/**
 * Fly-out tracking functions.
 * Handles Fly-Out Viewed and Fly-Out Clicked events.
 */

import { TRACKING_EVENTS, TRACKING_CATEGORIES } from '../constants/analytics'
import { getTrackingConfig, safeTrack } from './config'

/**
 * Formats event detail with optional locale suffix.
 */
const formatEventDetail = (eventDetail?: string, locale?: string): string => {
  if (!eventDetail) return ''
  return locale ? `${eventDetail}_${locale}` : eventDetail
}

/**
 * Tracks a fly-out viewed event (for modals, dropdowns, etc.)
 * Page tracking config is automatically retrieved from meta tags.
 *
 * @param label - The fly-out label
 * @param eventDetail - Optional event detail
 * @param locale - Optional locale (appended to eventDetail)
 */
export const trackFlyOutView = (label: string, eventDetail?: string, locale?: string): void => {
  const trackingConfig = getTrackingConfig()

  safeTrack(TRACKING_EVENTS.FLY_OUT_VIEWED, {
    ...trackingConfig,
    category: TRACKING_CATEGORIES.FLY_OUT,
    label,
    eventDetail: formatEventDetail(eventDetail, locale), // language instead of locale in case if language bar
  })
}

/**
 * Tracks a fly-out clicked event (for interactions within fly-outs)
 * Page tracking config is automatically retrieved from meta tags.
 *
 * @param label - The fly-out label
 * @param eventDetail - Optional event detail
 * @param locale - Optional locale (appended to eventDetail)
 */
export const trackFlyOutClick = (label: string, eventDetail?: string, locale?: string): void => {
  const trackingConfig = getTrackingConfig()

  safeTrack(TRACKING_EVENTS.FLY_OUT_CLICKED, {
    ...trackingConfig,
    category: TRACKING_CATEGORIES.FLY_OUT,
    label,
    eventDetail: formatEventDetail(eventDetail, locale),
  })
}
